import {useState, useEffect, type ReactNode} from 'react';

import {Modal} from 'shells/modal/modal';

import styles from './fullscreen-chart-wrapper.module.css';

interface Props {
    pivotFacetControlRenderer: () => ReactNode;
    children: ReactNode;
    chartHeight: number;
    shouldClose: boolean;
    onClose: () => void;
}

export const FullScreenChartWrapper = (props: Props) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    useEffect(() => {
        if (props.shouldClose) {
            setIsOpen(false);
        }
    }, [props.shouldClose]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={props.onClose}
            isCentered={true}
            closeButton={true}
            isWide={true}
            fitHeight={true}
        >
            <div className='pb-24'>
                <div className='mb-16 py-16'>{props.pivotFacetControlRenderer()}</div>
                <div style={{height: props.chartHeight}} className={styles['chart-wrapper']}>
                    {props.children}
                </div>
            </div>
        </Modal>
    );
};
